import { render } from "./RepeaterPropsCmp.vue?vue&type=template&id=20bac830"
import script from "./RepeaterPropsCmp.vue?vue&type=script&lang=js"
export * from "./RepeaterPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__